export default "__VITE_ASSET__DqOFmT8P__"